import { updateRefinements } from '@/components/SearchResultsFacets/utils';
import {
    FacetBucketNormalized,
    FacetNormalized,
} from '@/src/components/SearchResultsFacets/types';
import '@/types/contentStack';
import { useQueryParams } from '@nxt-costco-com/forge-digital-components';
import type { ContentStackEntryDataProps } from '@nxt-costco-com/forge-digital-components';

interface UseRefinementProps {
    searchService: 'lw' | 'grs' | null;
    facetConfig?: ContentStackEntryDataProps;
}

const useRefinement = ({ searchService, facetConfig }: UseRefinementProps) => {
    const { queryParams: searchParams, setQueryParams } = useQueryParams();

    const handleDoRefine = (
        facet: FacetNormalized,
        bucket: FacetBucketNormalized,
        isEnabled: boolean,
    ) => {
        updateRefinements(
            setQueryParams,
            facet,
            bucket,
            isEnabled,
            searchParams,
            searchService,
            facetConfig,
        );
    };

    return { handleDoRefine };
};

export default useRefinement;
